import { search } from '../utils';


export const filterPlaceByText = ({name, city, ref}, text) => {
  const re = search.createRegExp(text);
  return name?.match(re) || city?.match(re) || ref?.match(re)
}
